// Backend references
export const BASE_URL = process.env.BACKEND_URL;
export const API_BASE_URL = `${BASE_URL}/api`;

export enum VeevaDomain {
  PromoMats = 'VVPM',
  Medcomms = 'VVMC',
}

export const isVeevaMedcomms = (): boolean => {
  const veeva = sessionStorage.getItem('veeva-domain');
  if (veeva) {
    return veeva === VeevaDomain.Medcomms;
  }

  return process.env.VEEVA_DOMAIN === 'medcomms';
};
